var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconConnection = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0.272 0.497L6.564 0.497 6.564 6.792 0.272 6.792z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(.783 .5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.783 .5) translate(20.673 9.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M6.564 3.643c0 1.738-1.408 3.149-3.144 3.149-1.737 0-3.148-1.41-3.148-3.149C.272 1.905 1.682.496 3.42.496c1.736 0 3.144 1.41 3.144 3.147",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M20.85 27.208h6.289v-1.585c0-.284-.241-.523-.524-.523h-5.241c-.285 0-.523.24-.523.523v1.585zm-7.345 6.251h20.989v-4.17H13.505v4.17zm-3.083-7.296c-.55 0-1.002.449-1.002 1.002v8.418c0 .554.451 1.003 1.002 1.003.553 0 1.003-.45 1.003-1.003v-8.418c0-.553-.45-1.002-1.003-1.002zm27.156 0c-.552 0-1.002.449-1.002 1.002v8.418c0 .554.45 1.003 1.002 1.003.553 0 1.002-.45 1.002-1.003v-8.418c0-.553-.45-1.002-1.002-1.002zm-13.08-7.246h3.68c.575 0 1.041.467 1.041 1.04 0 .576-.466 1.042-1.04 1.042H25.05v2.02h1.565c1.436 0 2.604 1.169 2.604 2.604v1.585h5.276v-.043c0-1.7 1.383-3.083 3.083-3.083 1.7 0 3.083 1.383 3.083 3.083v8.418c0 1.7-1.383 3.084-3.083 3.084-1.7 0-3.083-1.383-3.083-3.084v-.042h-20.99v.042c0 1.7-1.382 3.084-3.083 3.084-1.699 0-3.083-1.383-3.083-3.084v-8.418c0-1.7 1.384-3.083 3.083-3.083 1.701 0 3.083 1.383 3.083 3.083v.043h5.264v-1.585c0-1.435 1.169-2.603 2.605-2.603h1.595V21h-3.16c-.573 0-1.04-.467-1.04-1.042 0-.574.467-1.04 1.04-1.04h4.688z",
    transform: "translate(.783 .5)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconConnection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_connection.dc1ca488bb1fa5951866b4cf4aa46976.svg";